'use strict';

import './photoLightboxModal.scss';
import template from './photoLightboxModal.template.html';
import controller from './photoLightboxModal.controller.js';

const component = {
    bindings: {},
    controller,
    template
};

export default component;
